// The user type last sent to GA this session, so the user_type_recorded event
// fires once rather than on every dashboard refresh.
let recordedUserType = null;

export function resetAnalyticsIdentity() {
  recordedUserType = null;
  if (typeof window.gtag === "function") {
    window.gtag("set", "user_properties", { user_type: null });
  }
}

// Records the type of user on the GA session as the `user_type` user property
// (eg "client", "estate_agent", "broker", "staff_app", "lead"), so dashboard
// traffic can be split by audience in GA and the BigQuery export.
//
// The property only attaches to events sent after it is set, and the initial
// page_view has already gone by the time /api/dashboard returns, so a
// user_type_recorded event is also sent to guarantee every session has at
// least one event carrying the user type.
//
// The email address is deliberately not sent: GA's terms prohibit sending
// personally identifiable information, and nothing here needs it yet.
//
// The event is addressed to the GA4 tag alone, and nothing is sent without
// one. gtag sends an event with no send_to to every configured tag, and the
// Google Ads tag (configured in the quote flow, see appConfig.gohtml) would
// treat it as a remarketing event.
export function updateAnalyticsIdentity(_emailAddress, userType) {
  const gaMeasurementId = window.appConfig?.ga_measurement_id;
  if (!userType || !gaMeasurementId || typeof window.gtag !== "function") {
    return;
  }
  window.gtag("set", "user_properties", { user_type: userType });
  if (recordedUserType !== userType) {
    recordedUserType = userType;
    window.gtag("event", "user_type_recorded", { user_type: userType, send_to: gaMeasurementId });
  }
}
